import type { AnalyticsEventParameters } from './analyticsController';

export type AnalyticsEventName =
  | 'login'
  | 'media_upload_completed'
  | 'media_playback_first_frame'
  | 'project_created'
  | 'split_video_started'
  | 'timeline_export_started'
  | 'timeline_export_completed';

type AnalyticsEventSink = (
  eventName: AnalyticsEventName,
  parameters?: AnalyticsEventParameters,
) => void;

let activeSink: AnalyticsEventSink | null = null;

export const registerAnalyticsEventSink = (sink: AnalyticsEventSink): (() => void) => {
  activeSink = sink;
  return () => {
    if (activeSink === sink) {
      activeSink = null;
    }
  };
};

export const trackAnalyticsEvent: AnalyticsEventSink = (eventName, parameters) => {
  activeSink?.(eventName, parameters);
};
